import { Box, styled } from '@mui/material';

import { DividingLineStyle } from './UneversityInfo.types';

const UIRowGap = 20;

export const UInfoContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: `${UIRowGap}px`,

  '@media screen and (min-width: 1920px)': {
    rowGap: `${UIRowGap * 2}px`,
  },
}));

export const UInfoTitleBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const UInfoDescriptionBox = styled(Box)(() => ({
  display: 'flex',
  maxWidth: '500px',

  '@media screen and (min-width: 1920px)': {
    maxWidth: '700px',
  },
}));

export const DividingLine = styled(Box)(
  ({ borderColor }: DividingLineStyle) => ({
    width: '100%',

    borderTop: `2px solid ${borderColor}`,
  }),
);

export const UILinkContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
}));
